// extracted by css-extract-rspack-plugin
export default {"ReadonlyCommentBoxContainer":"ReadonlyCommentBox-module__ReadonlyCommentBoxContainer__DyUsE","centeredContent":"ReadonlyCommentBox-module__centeredContent__WhreX"};